import React from "react";
import { MultiColumnList, TextLink } from "@folio/stripes/components";
import { FormattedMessage } from "react-intl";
import { useHistory } from "react-router-dom";
import { getContributionDisplayName } from "../utils/titleDisplay";
import { getPersonDetailPath } from "../utils/personNavigation";
export var TitleContributionsTable = function (_a) {
    var contributions = _a.contributions;
    var history = useHistory();
    var handlePersonClick = function (personId, legalForm) {
        var path = getPersonDetailPath(personId, legalForm);
        if (path) {
            history.push(path);
        }
    };
    return (React.createElement(MultiColumnList, { contentData: contributions, columnMapping: {
            sequenceNumber: (React.createElement(FormattedMessage, { id: "ui-br-agency.title.contributions.sequenceNumber.label" })),
            person: (React.createElement(FormattedMessage, { id: "ui-br-agency.title.contributions.person.label" })),
            role: (React.createElement(FormattedMessage, { id: "ui-br-agency.title.contributions.role.label" })),
            firstName: (React.createElement(FormattedMessage, { id: "ui-br-agency.title.contributions.firstName.label" })),
            lastName: (React.createElement(FormattedMessage, { id: "ui-br-agency.title.contributions.lastName.label" })),
            biographicalNote: (React.createElement(FormattedMessage, { id: "ui-br-agency.title.contributions.biographicalNote.label" })),
            name: (React.createElement(FormattedMessage, { id: "ui-br-agency.title.contributions.name.label" })),
        }, formatter: {
            sequenceNumber: function (item) { var _a; return ((_a = item.sequenceNumber) === null || _a === void 0 ? void 0 : _a.toString()) || "-"; },
            person: function (item) {
                var _a, _b;
                var displayName = getContributionDisplayName(item);
                var personId = (_a = item.person) === null || _a === void 0 ? void 0 : _a.id;
                var legalForm = (_b = item.person) === null || _b === void 0 ? void 0 : _b.legalForm;
                return personId && legalForm && displayName !== "" ? (React.createElement(TextLink, { onClick: function () { return handlePersonClick(personId, legalForm); } }, displayName)) : (displayName || "-");
            },
            role: function (item) {
                var _a;
                return ((_a = item.roles) === null || _a === void 0 ? void 0 : _a.map(function (r) { var _a; return (_a = r.role) === null || _a === void 0 ? void 0 : _a.description; }).filter(Boolean).join(", ")) || "-";
            },
            firstName: function (item) { return item.firstName || "-"; },
            lastName: function (item) { return item.lastName || "-"; },
            biographicalNote: function (item) {
                return item.biographicalNote || "-";
            },
            name: function (item) { return item.name || "-"; },
        }, visibleColumns: [
            "sequenceNumber",
            "person",
            "role",
            "firstName",
            "lastName",
            "biographicalNote",
            "name",
        ], isEmptyMessage: React.createElement(FormattedMessage, { id: "ui-br-agency.table.empty" }), interactive: false }));
};
